import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type ApiResponseError, fetchApiWithToken } from '~/api/utils'
import { ToastType } from '~/components/Global/Interactions/Toast/ToastType'
import { toast } from '~/utils'
import type { Invoice, UpdateInvoiceDto } from '../types'
import { getInvoiceErrorMessage } from '../utils/invoiceErrorMessage'

export const useUpdateInvoiceMutation = () => {
  const queryClient = useQueryClient()

  return useMutation<
    Invoice,
    ApiResponseError,
    { id: number; data: UpdateInvoiceDto }
  >({
    mutationFn: async ({ id, data }) => {
      return fetchApiWithToken<Invoice>({
        method: 'PATCH',
        url: `/v1/invoices/${id}`,
        data
      })
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['invoice', variables.id]
      })
      queryClient.invalidateQueries({ queryKey: ['invoices'] })
      toast(
        'Facture modifiée',
        'La facture a été modifiée avec succès',
        ToastType.Success
      )
    },
    onError: (error) => {
      toast(
        'Erreur lors de la modification',
        getInvoiceErrorMessage(
          error,
          'Une erreur est survenue lors de la modification de la facture'
        ),
        ToastType.Danger
      )
    }
  })
}
